import styled from 'styled-components'

export const StyledInput = styled.input`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
`
